import React, { forwardRef } from 'react';
import cx from 'classnames';
import s from './Multiselect.module.scss';
import FieldWrapper from '../FieldWrapper';
import { IconCheckmark } from '@/shared/ui/Icons';

type MultiselectProps = {
  items: {
    value: string;
    label: string;
    disabled?: boolean;
  }[];
  name: string;
  label?: string;
  labelInfo?: string;
  labelPostfix?: string;
  className?: string;
  inputClassName?: string;
  labelClassName?: string;
  multiSelectClassName?: string;
  type?: string,
  placeholder?: string,
  id?: string,
  hint?: string;
  error?: any;
  suffix?: any;
  prefix?: any;
  full?: boolean;
  isDisabled?: boolean;
  defaultValue?: string;
  [x:string]: any;
}

const Multiselect = forwardRef((props: MultiselectProps, ref) => {
  const {
    label,
    labelInfo = '',
    labelPostfix = '',
    className = '',
    labelClassName = '',
    multiSelectClassName = '',
    hint = '',
    error = '',
    full = true,
    items = [],
    isDisabled,
    defaultValue,
    name,
    ...restProps
  } = props;

  return (
    <FieldWrapper 
      label={label}
      labelInfo={labelInfo}
      labelPostfix={labelPostfix}
      className={className}
      hint={hint}
      error={error}
      full={full}
    >
      <div className={cx(s.container, multiSelectClassName)}>
        {items.map(({ value, label, disabled = false }) => {
          return (
            <label className={s.item} key={value}>
              <input
                type="checkbox"
                value={value}
                disabled={disabled}
                className={s.input}
                name={name}
                // @ts-ignore
                ref={ref}
                {...restProps}
              />
              <span className={s.itemInner}>
                <span className={s.checkmark}>
                  <IconCheckmark className={s.checkmarkIcon}/>
                </span>
                <span className={cx(s.label, labelClassName)}>
                  {label}
                </span>
              </span>
            </label>
          )
        })}
      </div>
    </FieldWrapper>
  );
});

Multiselect.displayName = 'Multiselect';

export default Multiselect;
